import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/var/www/farmtradedirect/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/farmtradedirect/src/app/haulage-job-board/components/HaulageJobBoardScreen.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/farmtradedirect/src/components/SiteHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/farmtradedirect/src/components/ui/AppIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/farmtradedirect/src/components/ui/AppLogo.tsx");
